'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgSalesforce(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("path", { d: "M6.99 4.719a2.117 2.117 0 011.525-.657c.793 0 1.482.444 1.85 1.1a2.553 2.553 0 011.05-.222C12.844 4.94 14 6.108 14 7.548c0 1.441-1.16 2.61-2.586 2.61a2.61 2.61 0 01-.508-.05 1.893 1.893 0 01-2.479.78 2.16 2.16 0 01-1.985 1.315 2.161 2.161 0 01-2.027-1.412A2.013 2.013 0 012 8.805 2.03 2.03 0 013.002 7.05 2.325 2.325 0 015.135 3.8c.757-.001 1.431.359 1.856.918", fill: "currentColor", fillRule: "evenodd" })));
}

module.exports = SvgSalesforce;
//# sourceMappingURL=Salesforce.js.map
